import CryptoJS from "react-native-crypto-js";

let crypto_key = "RzN3NiJ9eyJzdWIiDOiI2ISItInJkbGMo";

/**
 * 文字列を暗号化
 *
 * @param {*} data 暗号化対象データ
 */
 export function encrypt(data) {
  let encryptKey = '';
  if (data) {
    encryptKey = CryptoJS.AES.encrypt(data, crypto_key);
  }
  return encryptKey;
}

/**
 * 文字列を復号化
 *
 * @param {*} data 復号化対象データ
 */
export function decrypt(data) {
  let decryptKey = '';
  if (data) {
    decryptKey = JSON.parse(CryptoJS.AES.decrypt(data, crypto_key).toString(CryptoJS.enc.Utf8));
  }
  return decryptKey;
}